import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import { useMemo, useCallback } from "react";
import { Button, Form, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import { useFormik } from "formik";
import { DateRangePicker } from "rsuite";
import { BiSearch } from "react-icons/bi";
import { Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';

import Sidebar from "../../includes/Sidebar";
import { FileReportService } from "../../../services/FileReportService";
import FileReportDetails from "./FileReportDetails";
import { BsCloudDownloadFill } from "react-icons/bs";
import { downloadXl, predefinedBottomRanges } from "../../../functions";
import { Tooltip } from "@mui/material";
import { seErrorMessage } from "../../../slice/error/errorSlice";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from 'react-select';
import { useRef } from "react";
import { InvoiceReportService } from "../../../services/InvoiceReportService";
import { TbGridDots } from "react-icons/tb";
import { HiChevronDown } from "react-icons/hi";
import DownloadDropDown from "../../components/DownloadDropDown";
import { selectIsSuperUser, selectPermissions } from "../../../slice/user/userSlice";
import FilterUnMatchModal from "../../../utils/modal";
import { getUnmatchedKeys } from "../../../utils/objectUtils";
import ColumnModal from "./ColumnModal";


const datatableCustomStyles = {
  rows: {
    style: {
      minHeight: '20px', // override the row height
      fontSize: '0.7em',
      fontColor: '#212529 !important',
      width: '100%'
    },
  },
  headCells: {
    style: {
      paddingLeft: '5px', // override the cell padding for head cells
      paddingRight: '5px',
      textTransform: "uppercase",
      fontSize: '0.7em',
      fontWeight: '800',
      fontColor: '#6c757d !important',
      opacity: 1,
      minHeight: "10px",
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
      width: "100%",
    },
  },
  pagination: {
    style: {
      color: '#000',
      fontSize: '13px',
      minHeight: '56px',
      backgroundColor: '#fff',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: '#f2f2f2',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: '0px',
      cursor: 'pointer',
      transition: '0.4s',
      color: '#000',
      fill: '#000',
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: '#e2e2e2',
        fill: '#e2e2e2',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#f2f2f2',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#f5f5f5',
      },
    },
  },
};

function FileReport() {
  const dispatch = useDispatch()
  const facilityRef = useRef(null)
  const clientRef = useRef(null)

  const [reRenderDataTable, setRerenderDataTable] = useState(false)
  const [pageno, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isTimeCount, setisTimeCount] = useState(false);
  const [totalRows, setTotalRows] = useState(100);
  const [filterText, setFilterText] = useState('');
  const [colorRow, setColorRow] = React.useState({});
  const [data, setData] = useState({})
  const [limit, setLimit] = useState(100)
  const [searchedData, setSearchedData] = useState({
    search: "",
    date_range: `${moment(startOfMonth(new Date())).format('MM/DD/YYYY')} - ${moment(new Date()).format('MM/DD/YYYY')}`,
    hour_count: "",
    clients: [],
    facilities: [],
  })

  const [isFocusedClient, setIsFocusedClient] = useState(false);

  const [clients, setClients] = useState([]);

  const [isFocusedFacility, setIsFocusedFacility] = useState(false);

  const [selectValue, setSelectValue] = useState([])

  const [facilities, setFacilities] = useState([])

  const [selectIds, setSelectIds] = useState("")

  const [selectedFacility, setSelectedFacility] = useState([])

  const [selectedFacilityIds, setSelectedFacilityIds] = useState("")
  const [isInitSearch,setIsInitSearch] = useState(true)

  const [unmatchFilterModalShow, setUnmatchFilterModalShow] = useState(false);

  const handleModalClose = () => setUnmatchFilterModalShow(false);
  const handleModalShow = () => setUnmatchFilterModalShow(true);
  
  const [columnModalShow, setColumnModalShow] = useState(false);

  const handleColumnModalClose = (setSelectedColumn) => {setColumnModalShow(false);setSelectedColumn([])};
  const handleColumnModalShow = () => setColumnModalShow(true);


  const fileReportService = new FileReportService();
  const invoiceReportService = new InvoiceReportService()

  const { getFileReportSummery, downloadFileReportSummery, downloadFileReportSingle } = fileReportService
  const { getFacilityDropdown, getAllClientDropdown } = invoiceReportService



  const handlePerRowsChange = async (newPerPage, page) => {

    setLimit(newPerPage);
    setPageNo(1)
    fetchData(1, newPerPage, searchedData?.search, searchedData?.station, searchedData?.date_range, searchedData?.hour_count, searchedData?.clients, searchedData?.facilities);
    handleResetDataTable()

  };

  const handlePageChange = page => {
    setPageNo(page)
    fetchData(page, limit, searchedData?.search, searchedData?.station, searchedData?.date_range, searchedData?.hour_count, searchedData?.clients, searchedData?.facilities);
  };


  const fetchData = (page, limit, station, job_status, date_range, hour_count, clients, facilities) => {
    setLoading(true)
    setisTimeCount(hour_count == 'true' || hour_count == '' ? false : true)
    getFileReportSummery(page, limit, station, job_status, date_range, hour_count, clients, facilities).then((response) => {
      setData(response?.data);
      setLimit(limit);
      setPageNo(page)
      setTotalRows(response?.data?.count);
      setLoading(false);
      if (response?.errors?.date_range) {
        dispatch(seErrorMessage({ message: response?.errors?.date_range[0], is_show: true }))
      }
    });

  }




  const handleRowClickCheck = (row) => {
    data?.results.map((item, index) => {
      if (row?.id == item.id) {
        setColorRow(row)
      }
    })
  }
  const [expandedRows, setExpandedRows] = useState([]);

  const ExpandedComponent = useCallback(
    ({ data }) => (
      <pre>
        {expandedRows?.length > 0 && (
          <FileReportDetails
            report_page={1}
            report_limit={limit}
            report_station={""}
            report_job_status={""}
            report_date_range={searchedData?.date_range}
            report_hour_count={searchedData?.hour_count}
            clients={searchedData?.clients}
            facilities={searchedData?.facilities}
            facility_id={data?.facility_id}
            user={data.client_id}
          />
        )}
      </pre>
    ),
    [expandedRows, limit, searchedData]
  );

  const handleRowExpand = useCallback((row) => {
    const unmatchedkey = getUnmatchedKeys(searchedData, searchFormik.values)
    if (unmatchedkey.length > 0) {
      handleModalShow()
    }
    else {
    setColorRow(row);
    const isRowExpanded = expandedRows.includes(row);

    setExpandedRows(isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]);
    }
  });

  const searchFormik = useFormik({
    initialValues: {
      search: "",
      job_status: "",
      station: "",
      date_range: [startOfMonth(new Date()), new Date()],
      created_date: `${moment(startOfMonth(new Date())).format('MM/DD/YYYY')} - ${moment(new Date()).format('MM/DD/YYYY')}`,
      hour_count: "true",
      clients: [],
      facilities: []

    },validate: (value) => {
      console.log(value);
      const errors = {};
      if (!value?.date_range?.length > 0 && !value?.created_date.length > 0) {
        errors.date_range = "Required";
        errors.created_date = "Required";
      }
      return errors;
    },


    onSubmit: (values) => {
      setIsInitSearch(false)
      const client_ids = selectValue?.map(i => i.value)
      const facility_ids = selectedFacility?.map(i => i.value)
      values.clients = client_ids
      values.facilities = facility_ids
      searchData(values)

      setSearchedData({
        search: values?.search ? values?.search : "",
        job_status: values?.job_status ? values?.job_status : "",
        station: values?.station ? values?.station : "",
        date_range: values?.created_date ? values?.created_date : "",
        hour_count: values?.hour_count ? values?.hour_count : "",
        clients: values?.clients,
        facilities: values?.facilities,
      })
      handleResetDataTable()
    }
  })
  const handleModalOk =  () => {
    // Call the API here
      handleModalClose()
       searchFormik.handleSubmit() 
     
  };

  const columns = useMemo(
    () => [
      {
        id: 'S.NO',
        name: 'S.NO',
        selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
        wrap: true,
        width: "40px",
        grow: 0,

      },
      {
        id: 'client_name',
        name: 'CLIENT NAME',
        selector: row => row?.name,
        cell: (row) =>
          <div style={row?.name ? { height: 'auto' } : { height: '100%' }}>


            <div onClick={() => handleRowExpand(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '110px' }}>
              <div className='overflow-hidden text-truncate' style={{ maxWidth: "110px" }} >
                <Tooltip disableInteractive title={row?.name} placement="top" arrow>
                  <span className="text-truncate"> {row?.name}</span>
                </Tooltip>
              </div>
            </div>

          </div>
        ,


        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '130px'

      },
      {
        id: 'facility_name',
        name: 'FACILITY NAME',
        selector: row => row?.facility_name,
        cell: (row) =>
          <div style={row?.facility_name ? { height: 'auto' } : { height: '100%' }}>


            <div onClick={() => handleRowExpand(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '110px' }}>
              <div className='overflow-hidden text-truncate' style={{ maxWidth: "110px" }} >
                <Tooltip disableInteractive title={row?.facility_name} placement="top" arrow>
                  <span className="text-truncate"> {row?.facility_name}</span>
                </Tooltip>
              </div>
            </div>

          </div>
        ,


        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '120px'

      },
      {
        id: 'lbx',
        name: 'LBX',
        selector: row => row?.lock_box,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.lock_box}</span>,

        right: true,
        wrap: true,
        reorder: false,
        minWidth: '50px',

        // grow: 0.1,
      },
      {
        id: 'lbx_files',
        name: 'LBX FILES',
        selector: row => row?.lock_box_files,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.lock_box_files}</span>,

        right: true,
        wrap: true,
        reorder: false,
        minWidth: '50px',

        // grow: 0.1,
      },
      {
        id: 'index_files',
        name: 'INDEX FILES',
        selector: row => row?.index_files,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.index_files}</span>,

        right: true,
        wrap: true,
        reorder: false,
        minWidth: '50px',

        // grow: 0.1,
      },
      {
        id: 'auto_split',
        name: 'AUTO SPLIT',
        selector: row => row?.auto_split,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.auto_split}</span>,

        right: true,
        wrap: true,
        reorder: false,
        minWidth: '50px',

        // grow: 0.1,
      },
      {
        id: 'manual_split',
        name: 'MANUAL SPLIT',
        selector: row => row?.manual_split,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.manual_split}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0.1,
        minWidth: '100px'

      },


      {
        id: 'files_completed',
        name: 'FILES COMPLETED',
        selector: row => row?.files_completed,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.files_completed}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0.1,
        minWidth: '100px'

      },
      {
        id: 'files_rejected',
        name: 'FILES REJECTED',
        selector: row => row?.files_rejected,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.files_rejected}</span>,

        right: true,
        wrap: true,
        reorder: false,
        minWidth: '100px',

        // grow: 0.1,
      },


      {
        id: 'job_count',
        name: 'JOB COUNT',
        selector: row => row?.job_count,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.job_count}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0.1,
        minWidth: '50px',

        omit: isTimeCount

      },
      {
        id: 'claims_count',
        name: '# CLAIMS',
        selector: row => row?.claims_count,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.claims_count}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0.1,
        minWidth: '50px',

        omit: isTimeCount

      },
      {
        id: 'used_837_jobs',
        name: '# 837 USED-JOB',
        selector: row => row?.used_837,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.used_837}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0.1,
        minWidth: '100px',

        omit: isTimeCount
      },
      {
        id: 'used_837_claims',
        name: '# 837 USED-CLAIMS',
        selector: row => row?.used_837_claims,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.used_837_claims}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0.1,
        omit: isTimeCount,
        minWidth: '110px'

      },


    ],

    [handleRowExpand, limit, pageno, isTimeCount],
  );

  var i = 0;
  const conditionalRowStyles = [

    {
      when: row => colorRow.id == row.id ? true : false,
      style: (row, index) => ({
        backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
        color: 'black',
        // fontWeight: '550'
      }),
    },


  ];
  const handleRowClick = (row) => {
   
    const unmatchedkey = getUnmatchedKeys(searchedData, searchFormik.values)
    if (unmatchedkey.length > 0) {
      handleModalShow()
    }
    else { // setColorRow(row);
    // setExpandedRows([])
    setColorRow(row);
    const isRowExpanded = expandedRows.includes(row);

    setExpandedRows(isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]);
    }
  };



  const [datetime, setDateTime] = useState([]);

  const handleOnDateTimeChange = ({ name, value }) => {
    setExpandedRows([])
    let created_date = ""
    if (value !== null) {
      const startDate = value[0];
      const endDate = value[1];
      // Check if the start date is after the end date, and swap the dates if needed
      let isGreater = false
      if (startDate > endDate) {
        isGreater = true
      }
      const datefrom = moment(isGreater ? endDate : startDate).format('MM/DD/YYYY')
      const dateto = moment(isGreater ? startDate : endDate).format('MM/DD/YYYY')

      created_date = datefrom + " - " + dateto
    } else {
      setSearchedData({
        ...searchedData,
        created_date: '',
        date_range: '',
      })
      fetchData(1, limit, searchFormik?.values?.search, selectValue, "", searchFormik?.values?.hour_count);

    }

    setDateTime(created_date)

    searchFormik.setValues({ ...searchFormik.values, created_date, date_range: value ?? "" })


  }

  const searchData = ({ station, job_status, created_date, hour_count, clients, facilities }) => {
    fetchData(1, limit, station, '', created_date, hour_count, clients, facilities)
  }


  const permissions = useSelector(selectPermissions);
  const isSuperUser = useSelector(selectIsSuperUser);
  const isHavePermission = (name) => {
    return permissions?.includes(name) || isSuperUser
  }

  const showTooltip = (text, props) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );


  const handleResetDataTable = () => {
    setRerenderDataTable(true)
    // setTimeout(() => {
    //   setRerenderDataTable(false)
    // }, 200);
  }
  const [loader, setLoader] = useState(false);
  const handleDownloadSummury =(selectedColumns,setSelectedColumn) => {
    setLoader(true)
    handleColumnModalClose(setSelectedColumn)
    const client_ids = selectValue?.map(i => i.value)
    const facility_ids = selectedFacility?.map(i => i.value)
    const columns = selectedColumns?.map(i => i.value)
    downloadFileReportSummery({ page: 1, limit, ...searchFormik.values, clients: client_ids, facilities: facility_ids,columns }).then((response) => {
      setLoader(false)
      downloadXl(response?.data?.export_file)
    });
  }
  const handleDownload = (type = 'summury') => {
    if (type === 'summury') {
      handleColumnModalShow()
    }
    else {
      const client_ids = selectValue?.map(i => i.value)
      const facility_ids = selectedFacility?.map(i => i.value)
      setLoader(true)
      downloadFileReportSingle(1, limit, searchFormik.values?.search, selectValue, searchFormik.values.created_date, searchFormik.values?.hour_count, client_ids, facility_ids).then((response) => {
        setLoader(false)
        downloadXl(response?.data?.export_file)
      });
    }
  }


  const setFacilityOptions = (clientId) => {
    getFacilityDropdown(clientId).then((response) => {
      if (response && response.status) {
        setFacilities(response.data.facilities?.map(result => {
          return { options: result?.facilities, label: result?.client }

        }))

      }
    });
  }
  const [fullFacilities, setFullFacilities] = useState([])

  const checkSelectedFecilityInitialClient = (selectedOptions) => {

    // Initialize an empty result array and a set to track unique labels
    var result = [...selectValue];
    var uniqueLabels = new Set();
    const clientId = selectValue?.map((value) => String(value?.value))

    // Loop through selected options
    for (var i = 0; i < selectedOptions.length; i++) {
      var selectedOption = selectedOptions[i];

      // Loop through the list of dictionaries to find matching options
      for (var j = 0; j < fullFacilities.length; j++) {
        var options = fullFacilities[j].options;
        for (var k = 0; k < options.length; k++) {
          if (options[k].value === selectedOption.value && options[k].label === selectedOption.label) {
            // Check if the label is unique before adding it to the result
            console.log(clientId, fullFacilities[j].id)
            if (!uniqueLabels.has(fullFacilities[j].label) && !clientId.includes(String(fullFacilities[j].id))) {
              result.push({
                "value": Number(fullFacilities[j].id),
                "label": fullFacilities[j].label,
              });
              uniqueLabels.add(fullFacilities[j].label);
            }
            break;
          }
        }
      }
    }
    console.log("Result:", result);
    return result
  }
  // const handleSelectChange = (val, name = null) => {
  //   console.log(val)
  //   let selectedOptions = [];
  //   let selectedIds = [];

  //   if (val && val?.length > 0) {

  //     val?.map((option) => {
  //       selectedIds.push(option.value)
  //       selectedOptions.push(option)
  //     })

  //   } else {

  //     setSelectedFacility([])
  //     setSelectedFacilityIds([])
  //   }

  //   if (name == "facility") {
  //     const initiaClientsOptions = checkSelectedFecilityInitialClient(selectedOptions)
  //     // const clientIds = initiaClientsOptions?.map((value) => value?.value)
  //     setSelectedFacility(selectedOptions)
  //     setSelectedFacilityIds(selectedIds)
  //     setSelectValue(initiaClientsOptions)
  //     // setFacilityOptions(clientIds)
  //   } else {
  //     // setClients(val.includes('all') ? ['all'] : selectedId)
  //     if (!(val && val?.length > 0)) {
  //       if (clients && clients.length > 0) {
  //         const clientId = clients?.map((value) => value?.value)
  //         setFacilityOptions(clientId)
  //       }

  //     } else {
  //       getFacilityDropdown(selectedIds).then((response) => {
  //         if (response && response.status) {
  //           const feciltyIdArr = []
  //           setFacilities(response.data.facilities?.map(result => {
  //             console.log(result?.facilities, 'EEEEE')
  //             result?.facilities?.map(item => feciltyIdArr.push(item.value));
  //             return { options: result?.facilities, label: result?.client }

  //           }))

  //           const newArray = selectedFacility.filter(item => feciltyIdArr.includes(item.value));
  //           setSelectedFacility(newArray)
  //         }
  //       });

  //     }

  //     setSelectValue(selectedOptions)
  //     setSelectIds(selectedIds)
  //     // setSelectedFacility([])
  //   }
  // };
  const handleSelectChange = (val, name = null) => {
    let selectedOptions = [];
    let selectedIds = [];
    if (val && val?.length > 0) {

      val?.map((option) => {
        selectedIds.push(option.value)
        selectedOptions.push(option)
      })
    }
    if (name == 'facility') {
      setSelectedFacility(selectedOptions)
      setSelectedFacilityIds(selectedIds)
    }
    else if (name == 'client') {
      setSelectedFacility([])
      setFacilities([])
      setSelectValue(selectedOptions)
      setSelectIds(selectedIds)
      const feciltyIdArr = []
      console.log(clients)
      let clientoptions = []
      clients?.map(client => {
        clientoptions.push(client?.value)
      })
      console.log('selectedIds', selectedIds)
      getFacilityDropdown(selectedIds?.length ? selectedIds : clientoptions).then((response) => {
        if (response && response.status) {
          setFacilities(response.data.facilities?.map(result => {
            result?.facilities?.map(item => feciltyIdArr.push(item.value));
            return { options: result?.facilities, label: result?.client }

          }))
          const newArray = selectedFacility.filter(item => feciltyIdArr.includes(item.value));
          setSelectedFacility(selectedIds?.length ? newArray : [])
        }
      });
    }
  }
  const DropdownIndicator = ({ state, ...props }) => {
    console.log(state?.length, state)
    return (
      <components.DropdownIndicator {...props}>

        {state?.length > 1 ? (
          <TbGridDots style={{ fontSize: "1.5em" }} />
        ) : (
          <HiChevronDown style={{ fontSize: "1.5em" }} />
        )}



      </components.DropdownIndicator>
    );
  };
  useEffect(() => {
    searchFormik.validateForm()
    // fetchData(1, limit, searchFormik?.values?.search, '', searchedData.date_range, searchFormik?.values?.hour_count, '', '');
    getAllClientDropdown().then((response) => {
      if (response?.status) {
        const data = response?.data
        getFacilityDropdown(data.map((i) => i.value)).then((response) => {
          if (response && response.status) {
            const feciltyIdArr = []
            const FullFacilities = []
            setFacilities(response.data.facilities?.map(result => {
              result?.facilities?.map(item => feciltyIdArr.push(item.value));
              FullFacilities.push({ options: result?.facilities, label: result?.client, id: result?.pk })
              return { options: result?.facilities, label: result?.client, id: result?.pk }

            }))

            setFullFacilities(FullFacilities)
            const newArray = selectedFacility.filter(item => feciltyIdArr.includes(item.value));
            setSelectedFacility(newArray)
          }
        });

        setClients(data)
      }
    })
  }, [])
  useEffect(()=>{
   
    const client_ids = selectValue?.map(i => i.value)
    const facility_ids = selectedFacility?.map(i => i.value)
    searchFormik.setValues({...searchFormik.values,clients: client_ids,facilities:facility_ids})


},[selectedFacility,selectValue])
  return (
    <React.Fragment>
      {/* <Header /> */}
      <Sidebar />
      <main id="main" className="main">

        <div className="pagetitle tab-fixed-header">
          <h1 id='page-title'>File Report</h1>
        </div>

        <section className="section mt-5 ">
          <div className="row align-items-top py-2 gap-2 gap-md-5">
            <div className="col-lg-12">
              <div className="card mb-5 mb-xl-8" style={{ height: "92vh" }}>

                <Form onSubmit={searchFormik.handleSubmit} >
                  <div className=" ">
                    <div className="px-1 py-1 d-flex flex-row justify-content-start gap-2 align-items-center flex-wrap">
                      <div>
                        <Select
                          ref={clientRef}

                          isMulti
                          options={clients}
                          value={selectValue}
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state={selectValue} /> }}

                          className=""
                          classNamePrefix="select"
                          placeholder="Client"
                          menuPlacement="auto"
                          maxMenuHeight={300}
                          isClearable
                          name="client"
                          onChange={(val) => handleSelectChange(val, 'client')}
                          tabSelectsValue={false}
                          hideSelectedOptions={false}
                          onFocus={() => setIsFocusedClient(true)}
                          onBlur={() => setIsFocusedClient(false)}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none", boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: styles => ({
                              ...styles, width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: 'scroll',
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? '#d9f4f5' : 'inherit',
                              color: state.isSelected ? '#000000' : 'inherit',
                              '&:hover': { backgroundColor: state.isSelected ? '#d9f4f5' : 'rgb(222, 235, 255)' }

                            })
                          }}
                          menuPortalTarget={document.body}
                          closeMenuOnSelect={false} // Keep the menu open after selecting an option

                        />
                      </div>
                      <div>
                        <Select
                          tabSelectsValue={false}

                          ref={facilityRef}
                          options={facilities}
                          className=""
                          classNamePrefix="select"
                          placeholder="Facility"
                          menuPlacement="auto"
                          maxMenuHeight={300}
                          isClearable
                          isMulti
                          name="facility"
                          value={selectedFacility}
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state={selectedFacility} /> }}
                          hideSelectedOptions={false}

                          onChange={(val) => handleSelectChange(val, 'facility')}
                          onFocus={() => setIsFocusedFacility(true)}
                          onBlur={() => setIsFocusedFacility(false)}

                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none", boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: styles => ({
                              ...styles, width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: 'scroll',
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? '#d9f4f5' : 'inherit',
                              color: state.isSelected ? '#000000' : 'inherit',
                              '&:hover': { backgroundColor: state.isSelected ? '#d9f4f5' : 'rgb(222, 235, 255)' }

                            })
                          }}
                          menuPortalTarget={document.body}
                          closeMenuOnSelect={false} // Keep the menu open after selecting an option

                        />
                      </div>
                      <Tooltip disableInteractive title={"Deposit Date"} placement="top" arrow>

                      <div className= {`${searchFormik.errors.date_range ? "date-range-pickr-error ":""}  correspondenceDatePicker"`}>
                          <Stack direction="column" spacing={8} alignItems="flex-start">

                            <DateRangePicker
                              // style={{ backgroundColor: "#000" }}
                              ranges={predefinedBottomRanges}
                              cleanable={false}
                              placement="auto"
                              appearance="default" format={"MM/dd/yyyy"}
                              className="form-date-control form-control-solid b-r-1 text-dark"
                              placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                              name="date_range"
                              onChange={(e) => { handleOnDateTimeChange({ name: 'date_range', value: e }) }} value={searchFormik?.values?.date_range} />
                          </Stack>
                        </div>
                      </Tooltip>

                      <div>
                        <Tooltip disableInteractive title={"Search"} placement="top" arrow>
                          <Button className="btn btn-light btn-active-primary" type="submit">
                            <span className="svg-icon svg-icon-3">
                              <BiSearch />
                            </span>

                          </Button>
                        </Tooltip>
                      </div>
                      <div>
                        {isHavePermission("export_file_report_management") &&

                          <DownloadDropDown loader={loader} handleDownload={handleDownload} isDisabled={searchFormik.errors.date_range}  />
                        }
                      </div>

                    </div>
                  </div>

                </Form>


                <div className="card-body p-common">
                  <div className="table-responsive">
                    <div className="dashboardtable">
                      {/* {!reRenderDataTable && */}
                      <DataTable
                        className="custom-datatable"
                        paginationDefaultPage={pageno}
                        noDataComponent={isInitSearch ?<p className="p-4">Apply filters to refine and display the data</p> :<p className="p-4">There are no records to display</p>} 

                        fixedHeader={true}
                        progressPending={loading}
                        data={data?.results}
                        columns={columns}
                        pointerOnHover={true}
                        pagination
                        paginationServer
                        onRowClicked={handleRowClick}
                        // highlightOnHover
                        paginationTotalRows={totalRows}
                        paginationPerPage={limit}
                        paginationRowsPerPageOptions={[25, 50, 100, 150, 200]}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        conditionalRowStyles={conditionalRowStyles}
                        theme="solarized"
                        customStyles={datatableCustomStyles}
                        striped={true}
                        expandableRows
                        expandOnRowClicked={false}
                        onRowExpandToggled={handleRowExpand}
                        expandableRowsComponent={ExpandedComponent}
                        expandableRowsHideExpander
                        expandableRowExpanded={(row) => expandedRows.includes(row)}

                      />
                      {/* } */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FilterUnMatchModal
          show={unmatchFilterModalShow}
          handleClose={handleModalClose}
          handleModalOk={handleModalOk}
        />
        <ColumnModal 
        show={columnModalShow}
        handleClose={handleColumnModalClose}
        handleModalOk={handleDownloadSummury}
        columns={columns}
        loader={loader}
/>
      </main>
    </React.Fragment >
  )
}
export default FileReport




